<template>
  <div
    class="live-list-main-container"
    :style="{ height: viewportHeight + 'px' }"
  >
    <cube-scroll
      ref="scroll"
      :options="scrollOptions"
      @pulling-up="onPullingUp"
    >
      <div class="list-container">
        <div
          v-for="(item, index) in listData"
          :key="index"
          class="single-live-item"
          @click="goDetailLive(item)"
        >
          <img :src="item.image" class="live-image" />
          <img
            v-if="iconMap[item.status]"
            :src="iconMap[item.status]"
            class="left-corner-icon"
          />
          <div v-if="item.status === 'not_start'" class="extra-info">
            <span class="time-span">{{ item.start_time }}</span>
            <img
              :src="
                item.is_reserve
                  ? 'https://resource.chunyu.mobi/@/media/images/2022/12/07/38e5/790b6eb4d7a7_w174_h84_.png'
                  : 'https://resource.chunyu.mobi/@/media/images/2022/12/02/a126/3ef8430992d8_w512_h247_.png'
              "
              class="subscribe-button"
            />
          </div>
        </div>
      </div>
    </cube-scroll>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { visitRecordReport } from '@@/utils/pageVisitRecord.js';
import { getLiveList } from '@/services/index';

export default {
  name: 'Livelist',
  data() {
    return {
      iconMap: {
        not_start: '',
        started:
          'https://staff.chunyu.mobi/@/media/images/2022/11/23/f798/99314512ff50_w150_h57_.gif',
        finished:
          'https://staff.chunyu.mobi/@/media/images/2022/11/23/6dbb/888e6a8d1895_w150_h57_.png',
      },
      speakerUid: '',
      page: 1,
      listData: [],
      viewportHeight: '',
      isLoading: false,
      toastObj: {},
      visitReportPageName: '直播列表页', // 页面访问路径上报使用的业务名称
    };
  },
  computed: {
    scrollOptions() {
      return {
        pullUpLoad: {
          threshold: 0,
        },
        scrollbar: true,
      };
    },
    // 来源页面业务名称(上报访问路径使用)
    fromVisitPage() {
      return this.$route.query.from_visit_page || '';
    },
  },
  created() {
    this.speakerUid = this.$route.query.speaker_uid;
    this.viewportHeight = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );
    this.init();
    visitRecordReport({
      fromName: this.fromVisitPage || '',
      name: this.visitReportPageName || '',
      extraInfo: {},
    });
  },
  methods: {
    init() {
      this.getList();
    },
    goDetailLive(item) {
      window.location.href = `${item.jump_url}#OPEN_NEW_WIN`;
    },
    getList() {
      if (this.isLoading) return;
      this.showToast();
      this.isLoading = true;
      getLiveList({
        speaker_uid: this.speakerUid,
        page: this.page,
        count_per_page: 10,
      })
        .then(res => {
          if (res.error_code === 0) {
            this.page += 1;
            this.listData = [...this.listData, ...res.data.activity_list];
          } else {
            this.$createToast({
              time: 1000,
              txt: res.error_msg || '获取直播列表失败',
              type: 'txt',
            }).show();
          }
        })
        .finally(() => {
          this.hideToast();
          this.$refs.scroll.forceUpdate();
          this.$refs.scroll.refresh();
          this.isLoading = false;
        });
    },
    onPullingUp() {
      this.getList();
    },
    showToast() {
      try {
        this.toastObj.hide();
      } catch (error) {
        console.log(error);
      }
      this.toastObj = this.$createToast({
        txt: '加载中',
        mask: true,
      });
      this.toastObj.show();
    },
    hideToast() {
      try {
        this.toastObj.hide();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.live-list-main-container {
  display: flex;
  flex-flow: row wrap;
  overflow: hidden;

  .list-container {
    display: flex;
    flex-flow: row wrap;
    box-sizing: border-box;
    width: 100%;
    // height: 100%;
    padding: rem(10) rem(15) 0 rem(15);
    overflow: hidden;
    .single-live-item {
      position: relative;
      flex: 0 0 calc((100% - 10px) / 2);
      // align-self: center;
      box-sizing: border-box;
      margin-bottom: rem(15);
      overflow: hidden;
      border-radius: rem(8);
      &:nth-child(2n) {
        margin-left: 10px;
      }
      .live-image {
        width: 100%;
        object-fit: contain;
        border-radius: rem(8);
      }
      .left-corner-icon {
        position: absolute;
        top: 0;
        left: 0;
        width: rem(50);
        height: rem(19);
      }
      .extra-info {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        box-sizing: border-box;
        height: rem(44);
        padding: rem(8) rem(10);
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.0001) 2.27%,
          rgba(0, 0, 0, 0.584723) 100%
        );
        border-radius: 0 0 rem(8) rem(8);
        .time-span {
          color: #fff;
          font-size: rem(12);
        }
        .subscribe-button {
          display: block;
          flex: 0 0 rem(58);
          height: rem(28);
          margin-left: auto;
        }
      }
    }
  }
}
</style>
